import { createAction, createReducer } from '@reduxjs/toolkit';
import { get } from 'lodash-es';

const MODULE_PREFIX = '[ STOCK_NEWS ]';

const Actions = {
	getHotPursuit: `${MODULE_PREFIX} getHotPursuit`,
	setHotPursuitData: `${MODULE_PREFIX} setHotPursuitData`,
	setHotPursuitPullRefreshState: `${MODULE_PREFIX} setHotPursuitPullRefreshState`,
};

// actions
export const getHotPursuit = createAction(Actions.getHotPursuit);
export const setHotPursuitData = createAction(Actions.setHotPursuitData);
export const setHotPursuitPullRefreshState = createAction(Actions.setHotPursuitPullRefreshState);

// selectors

export const getHotPursuitData = (state) => {
	const hotPursuitData = get(state, 'stockNews.hotPursuitData', []);
	return hotPursuitData;
};

const initialState = {
	hotPursuitData: [],
	hotPursuitPullRefreshState: {},
};

// reducers
export default createReducer(initialState, (builder) => {
	builder.addCase(setHotPursuitData, (state, action) => {
		state.hotPursuitData = action.payload;
	});
	builder.addCase(setHotPursuitPullRefreshState, (state, action) => {
		state.hotPursuitPullRefreshState = action.payload;
	});
});
